import React from "react";
import "./index.scss";

export type ToggleType = {
  name: string;
  value: string;
  active?: boolean;
  key?: number;
};

export default ({
  toggles,
  updateToggle,
  onMouseUp
}: {
  toggles: ToggleType[];
  updateToggle: (toggle: string) => void;
  onMouseUp?: (toggle: string) => void;
}) => {
  return (
    <ul
      className={`generic__toggle active--${
        toggles.filter(t => t.active)[0].key
      }`}
    >
      {toggles.map(toggle => (
        <li
          key={toggle.key}
          className={`generic__toggle-item${!!toggle.active ? " active" : ""}`}
        >
          <button
            onMouseUp={() => onMouseUp && onMouseUp(toggle.value)}
            onClick={() => {
              updateToggle(toggle.value);
            }}
          >
            {toggle.name}
          </button>
        </li>
      ))}
    </ul>
  );
};
